import React from 'react';

//components
import SanityImage from 'components/SanityImage';
import {Link} from 'components/Link';

//domains
import type {FullImage} from 'domains/modules';

interface Props {
  module: FullImage;
}

export default function FullImage({module}: Props) {
  if (module.link) {
    if (module.link._type === 'linkInternal') {
      return (
        <Link to={`${module.link.slug}`} key={module._key}>
          <SanityImage
            layout="responsive"
            sizes={['50vw, 100vw']}
            src={module?.asset?._ref}
            alt={fullImageAlt(module)}
            loading="lazy"
            className="w-full object-cover"
          />
        </Link>
      );
    }
    if (module.link._type === 'linkExternal') {
      return (
        <a
          href={module.link.url}
          target={module.link.newWindow ? '_blank' : '_self'}
          rel="noreferrer noopener"
          key={module._key}
        >
          <SanityImage
            layout="responsive"
            sizes={['50vw, 100vw']}
            src={module?.asset?._ref}
            alt={fullImageAlt(module)}
            loading="lazy"
            className="w-full object-cover"
          />
        </a>
      );
    }
  }
  return (
    <SanityImage
      key={module._key}
      layout="responsive"
      sizes={['50vw, 100vw']}
      src={module?.asset?._ref}
      alt={fullImageAlt(module)}
      loading="lazy"
      className="w-full object-cover"
    />
  );
}

// A full-width image module is the Sanity image object itself, so the only
// text it can carry is the alt an editor typed on the asset. Without one it
// is decorative, and an empty alt tells assistive tech and crawlers exactly
// that — better than the missing attribute these shipped with.
function fullImageAlt(module: Props['module']): string {
  return (module as {alt?: string})?.alt?.trim() ?? '';
}
